import { Reducer } from 'redux'

import { IProcessorState, SliceComparator, TextOperation } from '../constants'
import { createRange } from '../range'

import { selectionReducer } from './selection'
import { createSlicesReducer } from './slices'
import { textReducer } from './text'

const createRootReducer = (
  slicesEqual?: SliceComparator,
): Reducer<IProcessorState, TextOperation> => {
  const slicesReducer = createSlicesReducer(slicesEqual)

  return (state, operation) => {
    const text = textReducer(state?.text, operation)
    const slices = slicesReducer(state?.slices, operation)
    let selection = selectionReducer(state?.selection, operation)

    if (selection.start > text.length) {
      selection = createRange(text.length)
    }

    if (selection.end > text.length) {
      selection = createRange(selection.start, text.length - selection.start)
    }

    if (
      typeof state === 'undefined' ||
      state.text !== text ||
      state.slices !== slices ||
      state.selection !== selection
    ) {
      return { text, slices, selection }
    }

    return state
  }
}

export default createRootReducer
